export default __webpack_public_path__ + "static/media/currency_icn.ffd141b7.png";